<template>
  <v-tooltip top>
    <v-btn :loading="loading" :disabled="disabled" icon slot="activator" @click="download()">
      <v-icon color="primary">file_download</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String,
    loading: Boolean,
    disabled: Boolean
  },
  methods: {
    download() {
      this.$emit("download");
    }
  }
};
</script>

<style>
</style>
